import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { FieldError } from "../common/States";

export default function ReasonDialog({ title, label, onConfirm, onClose, testId, placeholder = "Motif communiqué à l'entreprise par email", variant = "destructive" }) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    if (reason.trim().length < 5) { setError("Motif requis (5 caractères min.)"); return; }
    setBusy(true);
    await onConfirm(reason.trim());
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent data-testid={`${testId}-dialog`}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <Textarea rows={4} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} placeholder={placeholder} data-testid={`${testId}-reason-input`} />
        <FieldError>{error}</FieldError>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid={`${testId}-cancel`}>Annuler</Button>
          <Button variant={variant} onClick={confirm} disabled={busy} data-testid={`${testId}-confirm`}>{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{label}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
